<template>
  <div class="repairReq-main">
    <div class="repairReq-main-header">
      <p class="font-format-big text-center">请选择您的寄修产品</p>
      <!-- <div class="repairReq-type-select text-center">
        <el-radio v-model="selectType" :label="1"
          ><span class="font-format-normal">通过序列号识别</span>
        </el-radio>
        <el-radio v-model="selectType" :label="2"
          ><span class="font-format-normal">全系列产品</span></el-radio
        >
      </div> -->
    </div>
    <div class="repairReq-main-step1">
      <!-- <el-row v-if="selectType === 1" class="repairReq-main-step1-row">
        <el-col
          :xl="8"
          :lg="8"
          :md="8"
          :sm="24"
          class="repairReq-main-step1-left"
        >
          <p class="font-format-normal">请输入您的产品序列号</p>
          <p class="font-format-medium">
            通过产品序列号快速匹配产品型号及增值服务绑定状态。
          </p>
          <p class="font-format-medium">
            序列号中不含字母"O"和"I"，请输入数字"0"或"1"，也请注意数字和字母的区别，如数字"2"和字母"Z"。
          </p>
        </el-col>
        <el-col
          :xl="14"
          :lg="14"
          :md="14"
          :sm="24"
          class="repairReq-main-step1-right"
        >
          <div class="repairReq-sn-input">
            <el-input
              v-model="sn"
              placeholder="请输入序列号"
              size="normal"
              clearable
            ></el-input>
            <el-button type="primary" size="default">提交</el-button>
          </div>
          <el-link
            class="repairReq-sn-link"
            type="primary"
            icon="el-icon-warning"
            >如何查看序列号</el-link
          >
        </el-col>
      </el-row> -->

      <el-row v-if="selectType === 1" class="repairReq-main-step1-row">
        <el-col
          :xl="8"
          :lg="8"
          :md="8"
          :sm="24"
          class="repairReq-main-step1-left"
        >
          <p class="font-format-normal">产品型号搜索</p>
          <p class="font-format-medium">快速查找您的产品型号</p>
        </el-col>
        <el-col
          :xl="14"
          :lg="14"
          :md="14"
          :sm="24"
          class="repairReq-main-step1-right"
        >
          <div class="repairReq-sn-input">
            <el-input
              v-model="searchModelVal"
              placeholder="请输入产品型号"
              size="normal"
              @keyup.enter.native="searchModel"
              clearable
            ></el-input>
            <el-button type="primary" size="default" @click="searchModel"
              >搜索</el-button
            >
          </div>
          <!-- <el-link
            class="repairReq-sn-link"
            type="primary"
            icon="el-icon-warning"
            >如何查看序列号</el-link
          > -->
        </el-col>
      </el-row>

      <div class="repairReq-main-step1-tabs">
        <el-row class="repairReq-all-productLine">
          <el-col
            :xl="6"
            :lg="6"
            :md="6"
            :sm="24"
            class="repairReq-pane-label font-format-normal"
          >
            请选择产品尺寸
            <el-link type="primary" @click="showProductLine = !showProductLine"
              >[{{ showProductLine ? "收起" : "展开" }}]</el-link
            >
          </el-col>
          <el-col :xl="18" :lg="18" :md="18" :sm="24">
            <el-collapse-transition>
              <el-row v-if="showProductLine">
                <el-col
                  :xl="6"
                  :lg="6"
                  :md="6"
                  :sm="6"
                  :xs="12"
                  v-for="(size, index) of sizeData"
                  :key="index"
                >
                  <div
                    class="repairReq-common-size"
                    :class="{ activeProduct: sizeVal === size }"
                    @click="selectSize(size)"
                  >
                    <p class="font-format-medium omitText">
                      {{ size }}
                    </p>
                  </div>
                </el-col>
              </el-row>
            </el-collapse-transition>
          </el-col>
        </el-row>
        <el-row class="repairReq-all-commonData" v-if="productLine.length">
          <el-col
            :xl="6"
            :lg="6"
            :md="6"
            :sm="24"
            class="repairReq-pane-label font-format-normal"
          >
            请选择产品型号
          </el-col>
          <el-col :xl="18" :lg="18" :md="18" :sm="24">
            <el-row>
              <template v-for="(item, index) of productLine">
                <el-col
                  :xl="6"
                  :lg="6"
                  :md="6"
                  :sm="6"
                  :xs="12"
                  :key="index"
                  v-if="item.showUser === 'yes'"
                >
                  <div
                    class="repairReq-common-model"
                    @click="selectModel(item)"
                  >
                    <div
                      class="repairReq-common-model-info"
                      :class="{ activeProduct: modelVal.id === item.id }"
                    >
                      <!-- <img v-if="item.pic" :src="item.pic" alt="" /> -->
                      <!-- <el-image
                      v-if="item.pic"
                      style="max-width: 100px; height: 100px"
                      :src="item.pic"
                      fit="fill"
                    ></el-image>
                    <el-image
                      v-else
                      style="width: 100px; height: 100px"
                      fit="fill"
                      src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F01d1865543ec5b0000019ae91b12c1.jpg%401280w_1l_2o_100sh.jpg&refer=http%3A%2F%2Fimg.zcool.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1655624188&t=6fe2c50bc3fd73b779503e523824aa74"
                      alt=""
                    /> -->
                      <p class="font-format-medium" :title="item.name">
                        {{ item.name }}
                      </p>
                    </div>

                    <!-- <p class="font-format-medium" :title="item.name">
                      {{ item.name }}
                    </p> -->
                  </div>
                </el-col>
              </template>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="repairReq-step1-next">
      <div></div>
      <el-button
        type="primary"
        size="default"
        @click="nextPage"
        :disabled="!Object.keys(modelVal).length"
        >下一步</el-button
      >
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    device: {
      type: Object,
    },
  },
  data() {
    return {
      selectType: 1,
      tabType: "common",
      commonData: [],
      allData: [],
      sizeData: [],
      productLine: [],
      sizeVal: "",
      modelVal: {},
      showProductLine: true,
      searchModelVal: "",
    };
  },
  methods: {
    nextPage() {
      this.$emit("nextPage");
    },
    async setCurrentDeviceInfo() {
      await this.$nextTick();
      let item = this.allData.find((ele) => ele.name === this.device.model);
      if (!item) return;
      this.selectSize(item.size);
      this.selectModel(item);
    },
    async getList() {
      let res = await this.$http.getProductList();
      this.allData = res.data;
      this.sizeData = res.data.map((item) => item.size);
      this.sizeData = [...new Set(this.sizeData)];
      this.setCurrentDeviceInfo();
    },

    selectSize(size = "") {
      this.sizeVal = size;
      this.productLine = this.allData.filter((item) => item.size === size);
    },
    selectModel(item) {
      this.modelVal = item;
      this.device.model = item.name;
    },

    searchModel() {
      if (!this.searchModelVal) {
        return;
      }
      let arr = this.allData.filter(
        (item) =>
          ~item.name
            .toLocaleLowerCase()
            .indexOf(this.searchModelVal.toLocaleLowerCase())
      );
      if (!arr || !arr.length) return;
      this.productLine = arr;
    },
  },
  watch: {
    device: {
      handler() {
        this.setCurrentDeviceInfo();
      },
      deep: true,
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss">
.repairReq-main {
  .repairReq-main-header {
    text-align: center;
    border-bottom: 1px dashed #eee;
    padding: 30px 0;
    .repairReq-type-select {
      margin-top: 30px;
    }
  }
  .repairReq-main-step1 {
    /* padding: 30px 0; */
    /* border-bottom: 1px solid #eee; */
    .repairReq-main-step1-row {
      padding: 30px 0;
      .repairReq-main-step1-left {
        margin-right: 60px;
        > p + p {
          margin-top: 10px;
        }
      }
      .repairReq-main-step1-right {
        .repairReq-sn-input {
          width: 100%;
          display: flex;
          > .el-input {
            width: 80%;
            margin-right: 20px;
          }
          > .el-button {
            width: 20%;
          }
        }
        .repairReq-sn-link {
          margin-top: 10px;
        }
      }
    }

    .repairReq-main-step1-tabs {
      padding: 30px 0;
      .repairReq-pane-label {
        margin-bottom: 20px;
      }
      .repairReq-common-size {
        border: 1px solid #eee;
        margin: 0 10px 20px;
        padding: 10px;
        text-align: center;
        cursor: pointer;
        &:hover {
          border-color: $themeColor;
          > p {
            color: $themeColor;
          }
        }
      }
      .repairReq-common-model {
        margin: 0 10px 20px;
        padding: 10px;
        text-align: center;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        .repairReq-common-model-info {
          padding: 10px;
          border: 1px solid #eee;
          flex: 1;
          overflow: hidden;
          > img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        &:hover {
          > .repairReq-common-model-info {
            border-color: $themeColor;
          }
          .repairReq-common-model-info {
          }
        }
      }
      .repairReq-all-commonData {
        border-top: 1px dashed #eee;
        padding-top: 30px;
      }
    }

    .activeProduct {
      color: $themeColor;
      border-color: $themeColor !important;
      > p {
        color: $themeColor;
      }
    }
  }

  .repairReq-step1-next {
    padding-top: 30px;
    border-top: 1px solid #eee;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
  }
}

@media (max-width: 1000px) {
  .repairReq-main-step1-right {
    margin-top: 20px;
    .repairReq-sn-input {
      flex-direction: column;
      > .el-input {
        width: 100% !important;
      }
      > .el-button {
        margin-top: 20px;
        width: 100% !important;
      }
    }
  }
}

@media (max-width: 700px) {
  .repairReq-step1-next {
    position: absolute;
    left: 0;
    bottom: 10px;
    border: 0 !important;
    padding-top: 0px !important;
    box-shadow: 0 -1px 8px 4px #eee;
    > .el-button {
      width: 100% !important;
      border-radius: 0;
    }
  }
}
</style>
